import { NgModel } from '@angular/forms';

export class ValidationService {


  static allowAlphabets(event: any, browser: string) {

    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    if (event.target.value.substr(-1) == '.' && event.code == 'Period') {
      return false;
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if (
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122') ||
        event.which == '46' ||
        event.which == '32' ||
        event.which == '8' ||
        event.which == '0' ||
        event.which == '39' ||
        event.which == '9'
      )
        return true;
      else return false;
    } else {
      if (
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122') ||
        event.keyCode == '46' ||
        event.which == '39' ||
        event.keyCode == '32'
      )
        return true;
      else return false;
    }
  }

  static allowAlphabets2(event: any, browser: string, control: NgModel) {
    let invalid = /^([a-zA-Z '-]+)$/;
    if(!event.target.value.match(invalid)){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});

    }else{
      if(control.control.errors)
      delete  control.control.errors['nomatch'];

    }

    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    if (event.target.value.substr(-1) == '\'' && event.code == 'Quote') {
      return false;
    }
    if (event.target.value.substr(-1) === '-' && event.code === 'Minus') {
      return false;
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if (
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122') ||
        event.which == '32' ||
        event.which == '8' ||
        event.which == '0' ||
        event.which == '39' ||
        event.which == '9' || event.code === 'Minus'
      )
        return true;
      else return false;
    } else {
      if (
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122') ||
        event.which == '39' ||
        event.keyCode == '32' || event.code === 'Minus'
      )
        return true;
      else return false;
    }
  }

  static isNumeric2(event: any, browser: string, control: NgModel) {
    if(!event.target.value.match(/^[0-9\-\/]+$/) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true,'pattern':false});
    }else{
      if(control.control.errors)
      delete  control.control.errors['nomatch'];
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if ((event.keyCode >= 48 && event.keyCode <= 57))
        return true;
      else return false;
    } else {
      if ((event.keyCode >= 48 && event.keyCode <= 57))
        return true;
      else return false;
    }
  }

  static onlyNumeric(event: any, browser: string, control: NgModel) {
    if(!event.key.match(/^[0-9]+$/) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true,'pattern':false});
    }else{
      if(control.control.errors && control.control.hasError('nomatch'))
      delete  control.control.errors['nomatch'];
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if ((event.keyCode >= 48 && event.keyCode <= 57))
        return true;
      else return false;
    } else {
      if ((event.keyCode >= 48 && event.keyCode <= 57))
        return true;
      else return false;
    }
  }
  static oneSpaceAllowed(event: any) {
    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    return true;
  }

  static allowAlphaNumeric(event: any, browser: string) {
    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if (
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122') ||
        event.which == '46' ||
        event.which == '32' ||
        event.which == '8' ||
        event.which == '0' ||
        event.which == '9'
      )
        return true;
      else return false;
    } else {
      if (
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122') ||
        event.keyCode == '46' ||
        event.keyCode == '32'
      )
        return true;
      else return false;
    }
  }

  static validatePremiumAmountFormat(event: any, browser: string) {
    if (browser == 'Netscape' || browser == 'Opera') {
        if (event.which==0) return true;
        if (event.which==8) return true;
        if (event.which==9) return true;
        if (event.which <= 45 || event.which > 57 ) return false;
        if (event.which == 32) return false;
        if (event.which == 47) return false;
    } else {
        if (event.keyCode <= 45 || event.keyCode > 57 ) return false;
        if (event.keyCode == 32) return false;
        if (event.keyCode == 47) return false;
    }
    return false;
 }

  static ssnmask(ssn: any, control: NgModel) {
    let patt = /(\d{3}).*(\d{2}).*(\d{4})/;
    let donepatt = /^(\d{3})\-(\d{2})\-(\d{4})$/;
    let str = ssn.target.value;


    let result;
    if (!str.match(donepatt)) {
      result = str.match(patt);
      if (result != null ) {

        ssn.target.value = ssn.target.value.replace(/[^\d]/gi, '');
        str = result[1] + '-' + result[2] + '-' + result[3];
        ssn.target.value = str;

      } else {

        if (ssn.target.value.match(/[^\d\-]/gi) )
          ssn.target.value = ssn.target.value.replace(/[^\d]/gi, '');
      }

    }
    if(ssn.target.value.match(donepatt)){
      if(control.control.errors && control.control.hasError('pattern'))
      control.control.setErrors(null);
    }
    if(ssn.target.value.length == 11 && !ssn.target.value.match(donepatt)){
      ssn.target.value = ssn.target.value.replace(/[^\d]/gi, '');
      ssn.target.value = ValidationService.ssnmask(ssn, control);
    }
    return ssn.target.value;
  }


  static zipmask2(zipCode: any, control: NgModel) {
    let pat= /(^\d{5}$)|(^\d{5}-\d{4}$)/;
    let pat3=/(\d{5}).*(\d{4})/;
    let str = zipCode.target.value;
    let result;
    if(str.match(pat)){
      return zipCode.target.value;
    }else {
      result = str.match(pat3);
      if (result != null) {


          zipCode.target.value = zipCode.target.value.replace(/[^\d]/gi, '');
          str = result[1] + '-' + result[2];
          zipCode.target.value = str;


      } else {
        if (zipCode.target.value.match(/[^\d\-]/gi))
        zipCode.target.value = zipCode.target.value.replace(/[^\d]/gi, '');
      }
    }
    if(zipCode.target.value.match(pat)){
      if(control.control.errors && control.control.hasError('pattern'))
      control.control.setErrors(null);
    }
    if(zipCode.target.value.length == 10 && !zipCode.target.value.match(pat)){
      zipCode.target.value = zipCode.target.value.replace(/[^\d]/gi, '');
      zipCode.target.value = ValidationService.zipmask2(zipCode, control);
    }
    return zipCode.target.value;
  }



  static phonemask2(phone: any, control: NgModel) {
    let patt1 = /(\d{3}).*(\d{3}).*(\d{4})/;
    let donepatt = /^(\d{3})\-(\d{3})\-(\d{4})$/;

    if (phone.target.value.charAt(0) == '0' ) {
      phone.target.value = phone.target.value.replace('0', '');
    }
    let str = phone.target.value;
    if (!str.match(donepatt)) {
      let result = str.match(patt1);
      if (result != null) {
        phone.target.value = phone.target.value.replace(/[^\d]/gi, '');
        str = +result[1] + '-' + result[2] + '-' + result[3];
        phone.target.value = str;
      } else {
        if (phone.target.value.match(/[^\d\-]/gi))
          phone.target.value = phone.target.value.replace(/[^\d]/gi, '');
      }
    }
    if(phone.target.value.match(donepatt)){
      if(control.control.errors && control.control.hasError('pattern'))
      control.control.setErrors(null);
    }
    if(phone.target.value.length == 12 && !phone.target.value.match(donepatt)){
      phone.target.value = phone.target.value.replace(/[^\d]/gi, '');
      phone.target.value = ValidationService.phonemask2(phone, control);
    }

    return phone.target.value;
  }



  static datemask2(date: any, control: NgModel) {
    let donepatt = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    let patt = /(\d{2}).*(\d{2}).*(\d{4})/;
    let str = date.target.value;
    let result;

    if (!str.match(donepatt)) {
      result = str.match(patt);
      if (result != null) {
        date.target.value = date.target.value.replace(/[^\d]/gi, '');
        str = result[1] + '/' + result[2] + '/' + result[3];
        date.target.value = str;
      } else {
        if (date.target.value.match(/[^\d\/]/gi))
          date.target.value = date.target.value.replace(/[^\d]/gi, '');
      }
    }
    if(date.target.value.match(donepatt)){
      if(control.control.errors && control.control.hasError('pattern'))
      control.control.setErrors(null);
    }
    if(date.target.value.length > 0 && control.control.errors && control.control.hasError('required')){
      control.control.setErrors(null);
    }
    if(date.target.value.length <= 10 && !date.target.value.match(donepatt)){
      date.target.value = date.target.value.replace(/[^\d]/gi, '');
      result = date.target.value.match(patt);
      if (result != null) {
        date.target.value = date.target.value.replace(/[^\d]/gi, '');
        str = result[1] + '/' + result[2] + '/' + result[3];
        date.target.value = str;
      } else {
        if (date.target.value.match(/[^\d\/]/gi))
          date.target.value = date.target.value.replace(/[^\d]/gi, '');
      }
    }
    if(date.target.value.length > 7){
    return date.target.value;
    }
  }

  static validatePremiumAmount(event: any,control:NgModel) {
    let monthlyIns = event.target.value;
    if (monthlyIns != '') {
      if (monthlyIns.indexOf('.') > 0) {
        let beforepoint = monthlyIns.split('.')[0];
        if (monthlyIns.split('.')[1].length == 0) {
          event.target.value = beforepoint + '.' + '00';
        } else if (monthlyIns.split('.')[1].length == 1) {
          event.target.value =
            beforepoint + '.' + monthlyIns.split('.')[1] + '0';
        } else {
          event.target.value = beforepoint + '.' + monthlyIns.split('.')[1];
        }
      } else {
        event.target.value = monthlyIns + '.' + '00';
      }
      //control.control.setValue(event.target.value);
    }
  }


  static getSSNUsedMessage2( faxNo: string | null| undefined) {
    let callUs = '. Please contact us at ' + faxNo + '.';

    return 'This SSN is already associated with a case in our system' + callUs;
  }
  static getMessageServerDown() {
    return 'The server is down in our site, please call us at 1-844-715-4357 so we can further assist you.';
  }

  static isSSNValidValue(ssnValue: any) {
    if (!ssnValue || ssnValue == null || ssnValue == undefined) {
      return false;
    }
    
    if (
      ssnValue.substring(0, 3) == '000' ||
      ssnValue.substring(4, 6) == '00' ||
      ssnValue.substring(7, 11) == '0000' ||
      ssnValue == '111-11-1111' ||
      ssnValue == '222-22-2222' ||
      ssnValue == '333-33-3333' ||
      ssnValue == '444-44-4444' ||
      ssnValue == '555-55-5555' ||
      ssnValue == '666-66-6666' ||
      ssnValue == '777-77-7777' ||
      ssnValue == '888-88-8888' ||
      ssnValue == '999-99-9999'
    ) {
      return false;
    }
    return true;
  }
  static isMedicaidValid(medicaid: any) {
    if (medicaid ==  '0000000000' || medicaid == '1111111111' ||
    medicaid == '2222222222' || medicaid == '3333333333' ||
    medicaid == '4444444444' || medicaid == '5555555555' ||
    medicaid == '6666666666' || medicaid == '7777777777' ||
    medicaid == '8888888888' || medicaid == '9999999999') {
      return false;
    }
    return true;
  }
  static isFEINValidValue(empFEIN: any) {
    if (
      empFEIN.substring(0, 2) == '00' ||
      empFEIN ==  '00-0000000' ||
      empFEIN ==  '11-1111111' ||
      empFEIN ==  '22-2222222' ||
      empFEIN ==  '33-3333333' ||
      empFEIN ==  '44-4444444' ||
      empFEIN ==  '55-5555555' ||
      empFEIN ==  '66-6666666' ||
      empFEIN ==  '77-7777777' ||
      empFEIN ==  '88-8888888' ||
      empFEIN ==  '99-9999999'
    ) {
      return false;
    }
    return true;
  }
  static empFEINMask(empFEIN: any,control: NgModel) {
    let pat= /(^\d{2}-\d{7}$)/;
    let pat3=/(\d{2}).*(\d{7})/;
    let str = empFEIN.target.value;

    let result;
    if(str.match(pat)){
      return empFEIN.target.value;
    }else {
      result = str.match(pat3);
      if (result != null) {


        empFEIN.target.value = empFEIN.target.value.replace(/[^\d]/gi, '');
          str = result[1] + '-' + result[2];
          empFEIN.target.value = str;


      } else {
        if (empFEIN.target.value.match(/[^\d\-]/gi))
        empFEIN.target.value = empFEIN.target.value.replace(/[^\d]/gi, '');
      }
    }
    if(empFEIN.target.value.match(pat)){
      if(control.control.errors && control.control.hasError('pattern'))
      control.control.setErrors(null);
    }
    if(empFEIN.target.value.length == 10 && !empFEIN.target.value.match(pat)){
      empFEIN.target.value = empFEIN.target.value.replace(/[^\d]/gi, '');
      empFEIN.target.value = ValidationService.empFEINMask(empFEIN, control);
    }
    return empFEIN.target.value;
  }
  static amountMask(amount: any,control: NgModel) {
    let pat= /^[0-9]{1,7}(\.[0-9]{0,2})?$/;
    let invalid = /^([a-zA-Z ]+)$/;
    amount.target.value=amount.target.value.replace(/^0+/,'');
    amount.target.value=amount.target.value.replace(/^\.+/,'');
    amount.target.value=amount.target.value.replace(/\.{2,}/,'');
    let str = amount.target.value;

    if(str.match(invalid)){
      control.control.setErrors({...(control.errors || {}),'nomatch': true,'pattern':false});

    }else{
      if(control.control.errors)
          delete  control.control.errors['nomatch'];
    }
    let result;
    if(str.match(pat)){
      return amount.target.value;
    }else {
      result = str.match(pat);
      if (result == null) {
        amount.target.value = amount.target.value.replace(/[^[0-9\.]/gi, '');
      }
      // if(amount.target.value!='')
      //     amount.target.value=parseFloat(amount.target.value).toFixed(2)
    }
    return amount.target.value;
  }

  static allowAlphaNumericWithSplChar(event: any, browser: string) {
    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    if (event.target.value.substr(-1) == '-' && event.code == 'Minus') {
      return false;
    }
    if (event.target.value.substr(-1) == '/' && event.code == 'Slash') {
      return false;
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if (event.keyCode == '47' || event.keyCode == '45'||
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122') ||
        event.which == '8' ||
        event.which == '0' ||
        event.which == '9' ||
        event.which == '32' )

        return true;
      else return false;
    } else {
      if (event.keyCode == '47' || event.keyCode == '45'||
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122') ||
        event.which == '32'
      )
        return true;
      else return false;
    }
  }
  static allowOnlyOneAlphabet(event: any, browser: string, control: NgModel) {
    let invalid = /^[A-Za-z]{1}$/;
    /*if(!event.target.value.match(invalid)){
      control.control.setErrors({...(control.errors || {}),'nomatch': true,'required':false});

    }else{
      if(control.control.errors)
      delete  control.control.errors['nomatch'];

    }*/

    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if (
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122')

      )
        return true;
      else return false;
    } else {
      if (
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122')
      )
        return true;
      else return false;
    }
  }

  static formatPhoneNumber(phoneNumberString: any) {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
  }

  static allowAlphaNumericWithSpace(event: any,browser: string, control: NgModel) {
    let invalid = /^[A-Za-z0-9 ]+$/;
    if(!event.target.value.match(invalid)){
      control.control.setErrors({...(control.errors || {}),'nomatch': true,'required':false});

    }else{
      if(control.control.errors)
      delete  control.control.errors['nomatch'];

    }
    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if (
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122') ||
        event.which == '32'
      )
        return true;
      else return false;
    } else {
      if (
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122') ||
        event.keyCode == '32' ||
        event.keyCode == '35'
      )
        return true;
      else return false;
    }
  }
  static allowAlphaNumericWithSplHash(event: any,browser: string) {
    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if (
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122') ||
        event.which == '32' ||
        event.keyCode == '35'
      )
        return true;
      else return false;
    } else {
      if (
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122') ||
        event.keyCode == '32' ||
        event.keyCode == '35'
      )
        return true;
      else return false;
    }
  }
  static allowAlphaNumericWithTwoSplChar(event: any, browser: string,control: NgModel) {
    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    if (event.target.value.substr(-1) == '-' && event.code == 'Minus') {
      return false;
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if (event.keyCode == '32' || event.keyCode == '45'||
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122')  )

        return true;
      else return false;
    } else {
      if (event.keyCode == '32' || event.keyCode == '45'||
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122') 
      )
        return true;
      else return false;
    }
  }

  static allowAlphaNumericWithSplChars(event: any, browser: string,control: NgModel) {
    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    if (event.target.value.substr(-1) == '-' && event.code == 'Minus') {
      return false;
    }
    if (event.target.value.substr(-1) == '.' && event.code == 'Period') {
      return false;
    }
    if (event.target.value.substr(-1) == ',' && event.code == 'Comma') {
      return false;
    }
    if (event.target.value.substr(-1) == '#' && event.code == 'Digit3') {
      return false;
    }
    if (event.target.value.substr(-1) == '&' && event.code == 'Digit7') {
      return false;
    }
    if (event.target.value.substr(-1) == '/' && event.code == 'Slash') {
      return false;
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if (event.keyCode == '32' || event.keyCode == '45'||
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122') ||
        (event.which == '47' || event.which == '38' || event.which == '46' || event.which == '35' 
         || event.which == '44' 
          )
        )

        return true;
      else return false;
    } else {
      if (event.keyCode == '32' || event.keyCode == '45'||
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122') ||
        (event.which == '47' || event.which == '38' || event.which == '46' || event.which == '35' 
          || event.which == '44' 
           )
      )
        return true;
      else return false;
    }
  }
  static allowAlphaNumericWithoutSpace(event: any,browser: string, control: NgModel) {
    if (browser == 'Netscape' || browser == 'Opera') {
      if (
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122')
       
      )
        return true;
      else return false;
    } else {
      if (
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122')
      )
        return true;
      else return false;
    }
  }
  static allowAlphaNumericForCarrier(event: any, browser: string,control: NgModel) {
  
    if (event.target.value.substr(-1) == ' ' && event.code == 'Space') {
      return false;
    }
    if (event.target.value.substr(-1) == '-' && event.code == 'Minus') {
      return false;
    }
    if (event.target.value.substr(-1) == '/' && event.code == 'Slash') {
      return false;
    }
    if (event.target.value.substr(-1) == '(' && event.code == 'Digit9') {
      return false;
    }
    if (event.target.value.substr(-1) == ')' && event.code == 'Digit0') {
      return false;
    }
    if (browser == 'Netscape' || browser == 'Opera') {
      if (event.keyCode == '40' || event.keyCode == '41' || event.keyCode == '32'|| event.keyCode == '45'|| event.keyCode == '47' ||
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.which >= '65' && event.which <= '90') ||
        (event.which >= '97' && event.which <= '122')  )

        return true;
      else return false;
    } else {
      if (event.keyCode == '40' || event.keyCode == '41' || event.keyCode == '32'|| event.keyCode == '45'|| event.keyCode == '47' ||
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= '65' && event.keyCode <= '90') ||
        (event.keyCode >= '97' && event.keyCode <= '122') 
      )
        return true;
      else return false;
    }
  }
}
